import { Box, Button, Typography } from "@mui/material";
import LoadingSpinner from "./LoadingSpinner";


const SpecialDownloadButton = ({ type, mb }) => {
    return (
        <Box sx={{
            width: '270px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center',
            mb: mb
        }}>
            <Button sx={{
                width: '208px',
                background: '#000',
                color: '#fff',
                borderRadius: 999,
                height: '50px',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'start',
                pl: '35px',
                "&:hover": {
                    bgcolor: "#20BC71",
                    boxShadow: "none",
                    color: '#000',
                    "& .customIcon": {
                        background: "#000",
                    }

                },
            }}>
                <Box
                    className="customIcon"
                    sx={{
                        width: '8px',
                        height: '16px',
                        borderTopRightRadius: 999,
                        borderBottomRightRadius: 999,
                        background: '#fff',
                        mr: '14px'
                    }} />
                <Typography variant='text' sx={{ textTransform: "capitalize" }}>
                    {type}
                </Typography>
            </Button>
            <LoadingSpinner />
        </Box>
    )
}


export default SpecialDownloadButton;